









































































/*
    * Method for pupulate text input control - STARTS
    1. fieldSet     - Set of field names, these fields 'll be displayed as a group.
    2. pivot        - Pivot settings in the form group.
*/
import Vue from 'vue';
import { Component, Prop } from "vue-property-decorator";
import CrudContext from "./../../../../ContextMenu/CRUDContext.vue";
import TextInput from "./FieldTypes/TextInput.vue";
import TextArea from "./FieldTypes/TextArea.vue";
import Number from "./FieldTypes/Number.vue";
import ComboBox from "./FieldTypes/ComboBox.vue";
import MultiSelect from "./FieldTypes/MultiSelect.vue";
import Date from "./FieldTypes/Date.vue";
import File from "./FieldTypes/File.vue";
import Spacer from "./FieldTypes/Spacer.vue";

/*
    * Component's properties and events
*/
@Component({
    components: { 
        CrudContext,
        TextInput, 
        TextArea, 
        Number, 
        ComboBox, 
        MultiSelect,
        Date, 
        File,
        Spacer
    } 
})

export default class FormComponent extends Vue  {
    /*
        * Component's props
    */
    @Prop() readonly fieldset!: string;
    @Prop() readonly pivot!: string;

    /*
        * Component's variables
    */
    private isMobile: boolean = false;

    /*
        *  A component�s data option must be a function, so that each instance can maintain an independent copy of the returned data object.
        *  this.$options.parent.fileName - current componets name
    */
    data() {
        // @ts-ignore
        let context = this.$store.state[this.$options.parent.fileName];

        if (window.location.hash == '#0') {
            context.formData = {};
            context.editedItem = {};
        } else {
            context.disabled = true;
        }
        
        // @ts-ignore
        return context;
    }

    /*
        * Vuetify components look and feel change to mobile view
    */
    onResize() {
        if (window.innerWidth < 769) {
            //#.Enable mobile view
            this.$store.state.dashboard.isMobile = true;
            this.isMobile = true;
        } else {
            //#.Disable mobile view
            this.isMobile = false;
            this.$store.state.dashboard.isMobile = false;
        }
    }

    /*
        * Check if the context option is enabled or disabled
    */
    get appropriateContextMenu() {
        // @ts-ignore
        let context = this.$store.state[this.$options.parent.fileName];

        if (context.contextMenu)
            return "cm-for-list-item";
        else
            return null;
    } 
}
